module.exports = __webpack_public_path__ + "img/36-None of these.0f5dcf24.png";